import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Sports from "./pages/Sports/Sports";
import "./App.css";
import Auto from "./pages/Auto/Auto";
import Technology from "./pages/Technology/Technology";
import Home from "./pages/Home/Home";
import Entertainment from "./pages/Entertainment/Entertainment";
import Immigration from "./pages/Immigration/Immigration";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdvertisingPolicy from "./pages/AdvertisingPolicy";
import Heritage from "./pages/Heritage/Food";
import Food from "./pages/Heritage/Food";
import FoodDetail from "./pages/Heritage/DetailsPage";
// import Fashion from "./pages/Heritage/Fashion";
// import Astrology from "./pages/Heritage/Astrology";
import Beauty from "./pages/Heritage/Beauty";
import BeautyDetails from "./pages/Heritage/BeautyDetails";
// import Shopping from "./pages/Heritage/Shopping";
import Fitness from "./pages/Heritage/Fitness";
import FitnessDetails from "./pages/Heritage/FitnessDetails";
import AncientFashion from "./pages/Heritage/Fashion";
import Travel from "./pages/Travel/Travel";
import Goa from "./pages/Travel/Goa";
import GoaD from "./pages/Travel/GoaD";
import CityDetail from "./pages/Travel/CityDetail";
import Traveler from "./pages/Travel/Traveler";

// ......
import SouthAfricaImmigrationGuidelines from "./pages/Immigration/immsa";
import ThailandVisaGuide from "./pages/Immigration/immtl";
import SouthKoreaVisaGuide from "./pages/Immigration/immsk";
import ImmigrationVisa from "./pages/Immigration/ImmigirationVisa";
import AustralianImmigrationGuidelines from "./pages/Immigration/immaus";
import UKVisaGuidelines from "./pages/Immigration/immuk";
import NewZealandImmigrationGuidelines from "./pages/Immigration/immnw";
import NetherlandsImmigrationGuidelines from "./pages/Immigration/immnl";
import CanadaImmigrationGuidelines from "./pages/Immigration/immca";
import JapanImmigrationGuidelines from "./pages/Immigration/immjp";
import SwitzerlandImmigrationGuidelines from "./pages/Immigration/immsl";
import GermanyImmigrationGuidelines from "./pages/Immigration/immgy";
import USImmigrationGuidelines from "./pages/Immigration/Immusa";
import Health from "./pages/Health/Health";
import HealthDetail from "./pages/Health/HealthDetail";
import Footer from "./components/common/Footer";
import Feeder from "./pages/Feeder/Feeder";
import HomeMasterDetail from "./pages/Home/HomeMasterDetail";
import AdminDashboard from "./components/Portal/AdminDashboard";
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/homemaster/:id" element={<HomeMasterDetail />} />

          {/* Sports Routes */}
          <Route path="/sports/*" element={<Sports />} />

          {/* Sports Routes */}
          <Route path="/auto" element={<Auto />} />

          {/* Technology Routes */}
          <Route path="/technology" element={<Technology />} />

          {/* Entertainment Routes */}
          <Route path="/entertainment" element={<Entertainment />} />

          {/* Health Routes */}
          <Route path="/heritage" element={<Heritage />} />
          <Route path="/heritage/food" element={<Food />} />
          <Route path="/heritage/food/:name" element={<FoodDetail />} />
          <Route path="/heritage/fitness" element={<Fitness />} />
          <Route path="/heritage/fitness/:name" element={<FitnessDetails />} />
          <Route path="/heritage/beauty" element={<Beauty />} />
          <Route path="/heritage/beauty/:name" element={<BeautyDetails />} />
          <Route path="/heritage/fashion" element={<AncientFashion />} />
          {/* <Route path="/heritage/astrology" element={<Astrology />} />
          <Route path="/heritage/shopping" element={<Shopping />} /> */}
          <Route path="/heritage/fitness" element={<Fitness />} />

          {/* Health Routes */}
          <Route path="/health" element={<Health />} />
          <Route path="/health/:topicId" element={<HealthDetail />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/Advertising-policy" element={<AdvertisingPolicy />} />

          <Route path="/feeder/*" element={<Feeder />} />
          <Route path="/admin" element={<AdminDashboard />} />

          {/* Travel Routes */}
          <Route path="/travel" element={<Travel />} />
          <Route path="/traveler" element={<Traveler />} />
          <Route path="/goa-tourism" element={<Goa />} />
          <Route path="/goa" element={<GoaD />} />
          <Route path="/city/:cityName" element={<CityDetail />} />

          {/* Immigration Routes */}
          <Route path="/immigration" element={<Immigration />} />
          <Route path="/immigration/india" element={<ImmigrationVisa />} />
          <Route
            path="/immigration/usa"
            element={<USImmigrationGuidelines />}
          />
          <Route path="/immigration/uk" element={<UKVisaGuidelines />} />
          <Route
            path="/immigration/australia"
            element={<AustralianImmigrationGuidelines />}
          />
          <Route
            path="/immigration/NewZealand"
            element={<NewZealandImmigrationGuidelines />}
          />
          <Route
            path="/immigration/Netherlands"
            element={<NetherlandsImmigrationGuidelines />}
          />
          <Route
            path="/immigration/canada"
            element={<CanadaImmigrationGuidelines />}
          />
          <Route
            path="/immigration/japan"
            element={<JapanImmigrationGuidelines />}
          />
          <Route
            path="/immigration/Switzerland"
            element={<SwitzerlandImmigrationGuidelines />}
          />
          <Route
            path="/immigration/germany"
            element={<GermanyImmigrationGuidelines />}
          />
          <Route
            path="/immigration/south-africa"
            element={<SouthAfricaImmigrationGuidelines />}
          />
          <Route path="/immigration/thailand" element={<ThailandVisaGuide />} />
          <Route
            path="/immigration/south-korea"
            element={<SouthKoreaVisaGuide />}
          />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
